import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NatureGarantieService } from "src/app/parametrage/core/service/nature-garantie.service";
import { NatureGarantie } from "src/app/parametrage/core/model/garanties/nature-garantie";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddNatureGarantieComponent } from "./add-nature-garantie/add-nature-garantie.component";
import { SetTypeDocumentNatureGarantieComponent } from "./set-type-document-nature-garantie/set-type-document-nature-garantie.component";
import { SetTypeChampGarantieComponent } from "./set-type-champ-garantie/set-type-champ-garantie.component";
import { NgbdModalConfirm } from "src/app/core/services/utils/modal-confirm";
import { NgxSpinnerService } from "ngx-spinner";
import { finalize } from "rxjs/operators";

@Component({
  selector: "app-nature-garantie",
  templateUrl: "./nature-garantie.component.html",
  styleUrls: ["./nature-garantie.component.scss"],
})
export class NatureGarantieComponent implements OnInit {
  natureGaranties: NatureGarantie[];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _natureGarantieService: NatureGarantieService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.getListNatureGarantie();
  }

  getListNatureGarantie() {
    this._natureGarantieService.getListNatureGarantie().subscribe((data) => {
      console.log(data);
      this.natureGaranties = data;
    });
  }

  showDetail(group: NatureGarantie) {}

  editDetail(natureGarantie: NatureGarantie) {
    const modalRef = this.modalService.open(AddNatureGarantieComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "my-app-app-modal-class",
    });
    console.log(natureGarantie);
    modalRef.componentInstance.natureGarantie = natureGarantie;
    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getListNatureGarantie();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  deleteDetail(row) {
    //message en popup
    const modalConfirmRef = this.modalService.open(NgbdModalConfirm, {
      centered: true,
    });
    modalConfirmRef.componentInstance.title = "Suppression #" + row.id;
    modalConfirmRef.componentInstance.libelle = row.libelleNature;
    modalConfirmRef.componentInstance.queryMessage =
      "Etes-vous sûr de vouloir supprimer cet élément";
    modalConfirmRef.componentInstance.description =
      '<span class="text-danger"> Cette opération sera définitive.</span>';
    modalConfirmRef.componentInstance.btnMessage = "Oui, supprimer";

    modalConfirmRef.result.then(
      (result) => {
        this.spinner.show();
        this._natureGarantieService
          .delete(row.id)
          .pipe(
            finalize(() => {
              this.spinner.hide();
            })
          )
          .subscribe((data) => {
            this.getListNatureGarantie();
          });
      },
      (reason) => {
        console.log("reason", reason);
        //on dismiss
      }
    );
  }

  addNatureGarantie() {
    const modalRef = this.modalService.open(AddNatureGarantieComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "my-app-app-modal-class",
    });
    //modalRef.componentInstance.profile = this.profile;
    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getListNatureGarantie();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  setTypeDocumentGarantie(natureGarantie: NatureGarantie) {
    const modalRef = this.modalService.open(
      SetTypeDocumentNatureGarantieComponent,
      {
        centered: true,
        backdropClass: "light-blue-backdrop",
        backdrop: "static",
        windowClass: "my-app-app-modal-class",
        size: "lg",
      }
    );
    modalRef.componentInstance.natureGarantie = natureGarantie;
    modalRef.componentInstance.natureGarantieId = natureGarantie.id;
    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getListNatureGarantie();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  setChampGarantie(natureGarantie: NatureGarantie) {
    const modalRef = this.modalService.open(SetTypeChampGarantieComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      windowClass: "champ-modal-class",
    });
    modalRef.componentInstance.natureGarantie = natureGarantie;
    modalRef.componentInstance.natureGarantieId = natureGarantie.id;
    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        this.getListNatureGarantie();
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }
}
